import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';

// Confirmed roles: 1 = Owner, 2 = Admin (KT). Unknown ids fall back to "Role N" so
// the label is honest rather than guessed.
const ROLE_NAMES: Record<number, string> = { 1: 'Owner', 2: 'Admin' };

export function UserMenu() {
  const { identity, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!identity) return null;
  const roleName = ROLE_NAMES[identity.roleId] ?? `Role ${identity.roleId}`;
  const initial = (ROLE_NAMES[identity.roleId] ?? 'U').charAt(0);

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="header__user"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account menu"
        onClick={() => setOpen((o) => !o)}
      >
        <span className="header__avatar" aria-hidden="true">
          {initial}
        </span>
      </button>

      {open && (
        <div className="user-menu__panel" role="menu">
          <div className="user-menu__identity">
            <div className="user-menu__role">{roleName}</div>
            <div className="user-menu__meta">
              User #{identity.userId} · {identity.method}
            </div>
          </div>
          <button
            type="button"
            className="user-menu__item"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              navigate('/account');
            }}
          >
            Your account
          </button>
          <button
            type="button"
            className="user-menu__item"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              void logout();
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
